import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormArray, FormGroup } from '@angular/forms'
// import { LineOtherIncomeComponent } from '../line-other-income/line-other-income.component';
import { AddTikNumComponent } from '../add-tik-num/add-tik-num.component';

@Component({
  selector: 'app-internal-tik-num-array',
  templateUrl: './internal-tik-num-array.component.html',
  styleUrls: ['./internal-tik-num-array.component.scss']
})
export class InternalTikNumArrayComponent implements OnInit {

	@Input() public tiknumFormArray: FormArray;
	@Input() public displayErrors: boolean;
	@Input() public titles: string[];
	@Output() onAddFormGroup: EventEmitter<any> = new EventEmitter<any>();
	@Input() public tiknumType;
	@Output() onTikNumChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() public ph: string[];
	@Input() public buttons: string[];
	@Input() public qID: string;

	maxTikNumArrayLength = 4;


  constructor() { }

  	ngOnInit() {
	}

	emitTikNumChanges($event) {
	this.onTikNumChange.emit($event);
	}

	addTikNum() {
		this.onAddFormGroup.emit();
		this.displayErrors = this.tiknumFormArray.invalid;
			if (this.tiknumFormArray.valid)
			{
				this.tiknumFormArray.push(AddTikNumComponent.buildTikNum(''));
			}
	}

	simulateClick(event) {
		if ( event.keyCode === 13 ){
		  event.currentTarget.click();
		} 
	 }

  
	static buildTikNum(value:any) {
		let arr: FormGroup[]=[];
		if(value && value[0][0].answerValue) {
			value.forEach(element => {
				arr.push(AddTikNumComponent.buildTikNum(element));
			});
		}
		else{
			arr.push(AddTikNumComponent.buildTikNum(''));
		}
		return new FormArray(arr);
  }
}



// WEBPACK FOOTER //
// ./src/app/internal-tik-num-array/internal-tik-num-array.component.ts